export default "__VITE_ASSET__zPPmqnBB__"